export * from './lib/container/declaration/declaration.container';
export * from './lib/container/declaration/guards';
export * from './lib/feature-insurer-declaration-routing.module';
